import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
Vue.config.productionTip = false;

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

// 引入全局过滤器
import '@/utils/filters.js'

// import {baseURL} from '@/config/baseURL.js'
// Vue.prototype.uploadUrl = baseURL
// 全局都不知道这个uploadFile在哪里定义的，后补by zhangzhi on 20240912
import {baseURL, uploadFile} from '@/config/baseURL.js'
Vue.prototype.uploadUrl = baseURL
Vue.prototype.uploadFile = uploadFile
// Vue.prototype.uploadUrl = 'http://192.168.0.176:9001'

new Vue({
  router,
  store,
  render: (h) => h(App),
  data: {},
}).$mount("#app");

